import { render, staticRenderFns } from "./accept-fotos.vue?vue&type=template&id=18582c82&lang=pug&"
import script from "./accept-fotos.vue?vue&type=script&lang=js&"
export * from "./accept-fotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports